const extruderMaterialsMap = require('./extruderMaterialMap');
const { tools, SKETCH_LARGE } = require('./tools');

const getPrinterAttachedExtruders = (status) => {
  if (!status.toolheads || !status.toolheads.extruder || !status.toolheads.extruder.length) {
    throw new Error("This printer does not have proper extruder data.");
  }

  const printerAttachedExtruders = [];
  status.toolheads.extruder.forEach((extruder) => {
    if (
      status.type === SKETCH_LARGE.type_key ||
      status.machine_type === SKETCH_LARGE.type_key
    ) {
      printerAttachedExtruders.push(SKETCH_LARGE.name);
      return;
    }

    const name = extruder.tool_name || tools[extruder.tool_id].type_key;
    if (name != null) {
      printerAttachedExtruders.push(name)
    } else {
      throw new Error("Invalid extruder name")
    }
  });

  return printerAttachedExtruders;
};

const getPrinterMaterials = (status) => {
  // If the printer can't detect loaded filaments that's ok
  if (!status.loaded_filaments) {
    const materials = [];
    const attachedExtruders = getPrinterAttachedExtruders(status);
    attachedExtruders.forEach(extruder => {
      materials.push(...extruderMaterialsMap[extruder])
    });

    return materials;
  }

  return status.loaded_filaments;
};

module.exports = {
  getPrinterAttachedExtruders,
  getPrinterMaterials
};
